import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { InputIconModule } from 'primeng/inputicon';

@Component({
    selector: 'fcp-input-icon',
    imports: [InputIconModule],
    styleUrl: './fcp-input-icon.component.less',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `<p-inputicon [styleClass]="styleClass()">
        <ng-content />
    </p-inputicon>`
})
export class FcpInputIconComponent {
    styleClass = input<string | undefined>();
}
